import type { PaddingComponent, PresetComponent } from '@jscrypto/core';
import { padPkcs, unpadPkcs } from './pkcs-shared.js';

export const pkcs7: PaddingComponent<'Pkcs7'> = {
  kind: 'padding',
  name: 'Pkcs7',

  pad: padPkcs,

  unpad: unpadPkcs,
};

export const pkcs7Preset: PresetComponent<'pkcs7'> = {
  kind: 'preset',
  name: 'pkcs7',
  components() {
    return [pkcs7];
  },
};
